import Vue from 'vue';

import VueRouter from "vue-router";

import retina from 'retinajs'
import VueRetina from 'vue-retina'
import linkify from 'vue-linkify'

// window.Vue = require('vue');
window.VueRouter = require('vue-router');
export const eventBus = new Vue();
Vue.use(VueRetina, {retina})
Vue.use(require('vue-moment'));
Vue.use(VueRouter);
Vue.directive('linkified', linkify)


Vue.component('conversations', require('./components/messages/Conversations.vue').default);
Vue.component('create-conversation', require('./components/messages/CreateConversation.vue').default);

var router = new VueRouter({
    mode: 'history',
    routes: []
});

if (document.querySelector('#messages-vue')) {
    new Vue({
        el: '#messages-vue',
        router
    });
}

if(is_logged_in) {
    axios.get('/message/count')
        .then((response) => {
            setInitMessageCounter(response.data)
        });
}

function setInitMessageCounter(data) {

    if(data.message_count > 0) {
        $('.message-count').parent().show();
        $('.message-count').html(data.message_count);
    }else {
        $('.message-count').parent().hide();
    }

    Echo.private('users.' + data.user_id)
    .listen('MessageCount', (e) => {
        updateMessageCounter();
    });
}

function updateMessageCounter()
{
    axios.get('/message/count')
    .then((response) => {
        if(response.data.message_count == 0)
            $('.message-count').parent().hide();
        else {
            $('.message-count').parent().show();
            $('.message-count').html(response.data.message_count);
        }
    });
}



// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);


if ($('.dms-conversation__messages').length) {

	$('.dms-conversation__messages').scrollTop($('.dms-conversation__messages')[0].scrollHeight);

}


$('.dms-conversation__messages').on('scroll', function() {

	var scroll = $(this).scrollTop();
	var top;
	var bot;

	$('.conv-day').each(function() {

		top = $(this).position().top;
		bot = top + $(this).outerHeight();

		/*
		console.log('-------');
		console.log('scroll', scroll);
		console.log('top', top);
		console.log('bot', bot);

		 */

		if (top <= 0) {

			console.log('Greater than top: ', $(this));

			if (bot <= 0) {

				$(this).removeClass('fixed').addClass('bot');

			} else {

				$(this).removeClass('bot').addClass('fixed');

			}

		} else {

			$(this).removeClass('fixed bot');

		}

	});

});

// $('.dms-sidebar__tabs .tab').on('click', function() {

// 	var tar = $(this).data('tar');

// 	$(this).addClass('active').siblings().removeClass('active');
// 	$('#dms-' + tar).show().siblings('.dms-sidebar-tab').hide();

// });

$('.conv-dd-trigger').on('click', function() {

	$('.conv-dd').fadeToggle();

});

$('.hide-conv-trigger').on('click', function() {

	$('.dms-main').removeClass('active');

});


$('.compose-message-trigger').on('click', function() {

	$('.endorsed-modal__dms').fadeIn();

});

//This is just for the static build

$('.dms-sidebar__people li').on('click', function() {

	$('.dms-main').addClass('active');

});



